import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { list as woundList } from '../../api/homeWounds';
import { list as productList } from '../../api/products';
import { createWound, updateWound } from '../../api/wounds';
import { Button } from '../../components/Button';
import { Dropdown } from '../../components/Dropdown';
import { Modal } from '../../components/Modal';
import { ProductIdGroup } from '../../components/ProductIdGroup';
import { PlusIcon } from '../../icons/PlusIcon';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './wounds.styl';
var WoundsDetailsModal = /** @class */ (function (_super) {
    __extends(WoundsDetailsModal, _super);
    function WoundsDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            indicationInputError: false,
            protocolInputError: false,
            imageInputError: false,
            woundTypeInputError: false,
            indicationState: '',
            protocolState: '',
            linkedProductError: false,
            products: [],
            wounds: [],
        };
        _this.dropZone = null;
        _this.removeCount = 10;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.wound,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    attachedImage: response.data.fileName,
                });
                _this.dropZone.files = [];
            }
        };
        _this.onWoundSelected = function (wound) {
            _this.setState({
                selectedWoundType: wound,
            });
        };
        _this.onAddCombination = function () {
            var combinations = _this.state.linkedProductIds || [];
            if (combinations.length !== 0) {
                if (combinations[combinations.length - 1].length !== 0) {
                    combinations.push([]);
                    _this.setState({
                        linkedProductIds: combinations,
                    });
                }
            }
        };
        _this.onRemoveGroup = function (index) {
            var combinations = _this.state.linkedProductIds || [];
            combinations.splice(index, 1);
            _this.removeCount += 10;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        _this.onProductGroupChanged = function (index, group) {
            var combinations = _this.state.linkedProductIds || [];
            combinations[index] = group;
            _this.setState({
                linkedProductIds: combinations,
            });
        };
        return _this;
    }
    WoundsDetailsModal.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.wound) {
            var wound = this.props.wound;
            this.setState({
                protocolState: wound.protocol || '',
                indicationState: wound.indication || '',
                attachedImage: wound.image,
                linkedProductIds: (wound === null || wound === void 0 ? void 0 : wound.linkedProductIds) || [[]],
            });
        }
        else {
            this.setState({
                linkedProductIds: [[]],
            });
        }
        productList().then(function (products) {
            _this.setState({
                products: (products === null || products === void 0 ? void 0 : products.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        woundList().then(function (wounds) {
            var _a;
            _this.setState({
                wounds: (wounds === null || wounds === void 0 ? void 0 : wounds.items) || [],
                selectedWoundType: (_a = wounds === null || wounds === void 0 ? void 0 : wounds.items) === null || _a === void 0 ? void 0 : _a.find(function (w) { var _a; return w.id === ((_a = _this.props.wound) === null || _a === void 0 ? void 0 : _a.woundTypeId); }),
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    WoundsDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        var _a, _b, _c;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        if (this.state.selectedWoundType == null) {
            this.setState({ woundTypeInputError: true });
            valid = false;
        }
        var indications = (_a = this.indicationRef) === null || _a === void 0 ? void 0 : _a.getContent();
        if (isHtmlEmpty(indications)) {
            this.setState({ indicationInputError: true });
            valid = false;
        }
        var protocol = ((_b = this.protocolRef) === null || _b === void 0 ? void 0 : _b.getContent()) || '';
        if (isHtmlEmpty(protocol)) {
            // this.setState({protocolInputError: true});
            // valid = false;
        }
        var image = this.state.attachedImage;
        if (!image || image.length === 0) {
            this.setState({ imageInputError: true });
            valid = false;
        }
        var ids = this.state.linkedProductIds;
        if (!ids || ids.length === 0) {
            this.setState({ linkedProductError: true });
            valid = false;
        }
        var flatList = '';
        ids === null || ids === void 0 ? void 0 : ids.forEach(function (group) {
            if (group.length === 1 && group[0] === -10) {
                // Do not add group with only the infected id selected
            }
            else {
                if (flatList.length !== 0) {
                    flatList = flatList + ";";
                }
                flatList += group.join(',');
            }
        });
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            indications: indications,
            protocol: protocol,
            image: this.state.attachedImage,
            linkedProductIds: flatList,
            woundTypeId: (_c = this.state.selectedWoundType) === null || _c === void 0 ? void 0 : _c.id,
        };
        this.setState({ loading: true });
        if (this.props.wound) {
            request.id = this.props.wound.id;
            updateWound(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createWound(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    WoundsDetailsModal.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this, props = _c.props, state = _c.state;
        var i18n = props.store.i18n;
        var wound = props.wound;
        var loading = state.loading, indicationState = state.indicationState, protocolState = state.protocolState;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.woundsAddView },
                React.createElement("p", { className: S.woundsHeaderText }, props.wound ?
                    i18n.woundsSubUpdateTitle
                    :
                        i18n.woundsSubCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.sideBarWounds),
                        React.createElement(Dropdown, { maxHeight: 190, isFixed: true, className: "modalDropDown", boxClass: "modalDropDownBox", label: "" + (this.state.selectedWoundType ? this.state.selectedWoundType.title : i18n.inputChoose) },
                            React.createElement(Dropdown.List, null, (_a = this.state.wounds) === null || _a === void 0 ? void 0 : _a.map(function (homeWound, index) { return (React.createElement(Dropdown.Item, { key: index, data: "product", autoClose: true, onClick: function (_) { return _this.onWoundSelected(homeWound); } }, homeWound === null || homeWound === void 0 ? void 0 : homeWound.title)); }))),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.woundTypeInputError ? 'inputErrorActive' : '') }, i18n.validationWoundTypeError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: wound === null || wound === void 0 ? void 0 : wound.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIndication),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.indicationRef = editor; }, apiKey: getEditorKey(), initialValue: indicationState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.indicationInputError ? 'inputErrorActive' : '') }, i18n.validationIndicationError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIcon),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.attachedImage ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.attachedImage) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZone = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.imageInputError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputProductCombinations),
                        React.createElement("div", { className: S.combination }, state.products &&
                            React.createElement(React.Fragment, null, (_b = this.state.linkedProductIds) === null || _b === void 0 ? void 0 : _b.map(function (productIds, index) { return (React.createElement(ProductIdGroup, { key: index * _this.removeCount, index: index, productIds: productIds, products: state.products || [], onRemoveGroup: _this.onRemoveGroup, onProductGroupChanged: _this.onProductGroupChanged })); }))),
                        React.createElement("div", { className: S.woundAddButtonWrapper },
                            React.createElement(Button, { className: "" + S.woundAddButton, type: "button", onClick: this.onAddCombination },
                                React.createElement(PlusIcon, null),
                                " ",
                                i18n.inputAddCombination)),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.linkedProductError ? 'inputErrorActive' : '') }, i18n.validationSelectError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.woundsModalButton, type: "submit", spinner: loading }, props.wound ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.woundsModalButton + " " + S.woundsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], WoundsDetailsModal.prototype, "onSubmit", null);
    WoundsDetailsModal = __decorate([
        inject('store'),
        observer
    ], WoundsDetailsModal);
    return WoundsDetailsModal;
}(React.Component));
export { WoundsDetailsModal };
